import api from "../api";
import type { User } from "../auth";

export interface CallSession {
  id: string;
  type: "video" | "audio";
  status: "initiated" | "ringing" | "active" | "ended" | "declined" | "failed";
  conversationId: string;
  initiator?: User;
  participants: Array<{
    id: string;
    user: User;
    status: string;
    isInitiator: boolean;
  }>;
  startedAt?: string;
  endedAt?: string;
  duration?: number;
}

const callService = {
  createCall: async (data: {
    conversationId: string;
    participantId: string;
    type?: "video" | "audio";
  }): Promise<CallSession> => {
    const response = await api.post<CallSession>("calls", data);
    return response.data;
  },

  getCall: async (sessionId: string): Promise<CallSession> => {
    const response = await api.get<CallSession>(`calls/${sessionId}`);
    return response.data;
  },

  updateCallStatus: async (
    sessionId: string,
    action: "accept" | "decline" | "end",
  ): Promise<void> => {
    await api.put(`calls/${sessionId}/status`, { action });
  },

  sendIceCandidate: async (
    sessionId: string,
    candidate: any,
  ): Promise<void> => {
    await api.post(`calls/${sessionId}/ice`, candidate);
  },

  sendOffer: async (sessionId: string, offer: string): Promise<void> => {
    await api.post(`calls/${sessionId}/offer`, { offer });
  },

  sendAnswer: async (sessionId: string, answer: string): Promise<void> => {
    await api.post(`calls/${sessionId}/answer`, { answer });
  },
};

export default callService;
export const callsApi = callService;
